export default {
  unitRule: {
    unitRule: "Unit Rule",
    unitRuleCode: "Unit Rule Code",
    unitRuleName: "Unit Rule Name",
    unitRuleType: "Rule Type",
    collectionTarget: "Collection Target",
    usageCheck: "Usage Check",
    status: "Approval Status",
    unitRuleExist: "Unitrule is already existed"
  }
};
